import { environment as useEnvironment } from '@/utils/environmentUtils'
import type { AxiosRequestConfig } from 'axios'
import axios from 'axios'

const environment = useEnvironment()

export const baseURL = new URL(new URL(environment.VUE_APP_BE_URI).origin) // https://localhost:49153 https://api.avissign.com https://dev.api.avissign.com

export const apiKey = 'dsfgdfhilo898079xgr9BFQEmNAw/poBMwWwqaT===H0sw0v8akHSeZHBppZQ=='

export const resourceConfig: AxiosRequestConfig = {
  timeout: 60000 * 10,
  headers: {
    Accept: 'application/json',
  },
}

export const resourceClient = axios.create(resourceConfig)
